import { getInitials, getName } from "@/shared/utils/helperFunctions";
import { DEFAULT_USER } from "@/shared/utils/utils";

export const createUserSlice = (set) => ({
  user: DEFAULT_USER,
  // Org admin UI mode only
  appMode: "user",
  setAppMode: (mode) => set({ appMode: mode === "user" ? "user" : "admin" }),
  toggleAppMode: () =>
    set((state) => ({
      appMode: state.appMode === "admin" ? "user" : "admin",
    })),

  /** Sidebar collapsed/expanded state — persisted across refreshes. */
  sidebarExpanded: true,
  setSidebarExpanded: (val) => set({ sidebarExpanded: val }),
  toggleSidebar: () =>
    set((state) => ({ sidebarExpanded: !state.sidebarExpanded })),
  setUser: (payload = {}) =>
    set((state) => {
      const name = payload.name ?? state.user.name;
      const email = payload.email ?? state.user.email;
      const initials = name ? getName(name) : getInitials(email);

      return {
        user: {
          ...state.user,
          ...payload,
          initials,
          channels: {
            ...state.user.channels,
            ...payload.channels,
          },
        },
      };
    }),

  setChannelId: (channel, channelId) =>
      set((state) => ({
        user: {
          ...state.user,
          channels: {
            ...state.user.channels,
            [channel]: channelId,
          },
        },
      })),

  setOnboardingStatus: (isOnboarded) =>
    set((state) => ({
      user: {
        ...state.user,
        isOnboarded,
      },
    })),

  setOnboardingType: (type) =>
    set((state) => ({
      user: {
        ...state.user,
        onboardingType: type,
      },
    })),
});
